<template>
  <li class="p-item-list-panel-large">
    <div class="p-item-list-panel-large__content">
      <a
        :href="'/product-details/?id=' + premiumId"
        class="p-item-list-panel-large__thumbnail"
      >
        <img :style="setOpacity" :src="thumbnails[0].path" />
      </a>
      <div class="p-item-list-panel-large__info">
        <TextLabel
          v-if="status"
          :color="{ border: color, content: '#fff' }"
          :reverse="true"
          >{{ status }}</TextLabel
        >
        <a
          :href="'/product-details/?id=' + premiumId"
          class="p-item-list-panel-large__name"
          >{{ name }}</a
        >
        <p class="p-item-list-panel-large__id">商品NO.{{ premiumId }}</p>
        <div class="p-item-list-panel-large__item__details">
          <ItemSpecs
            v-if="showSpecs"
            :specs="getSpecs(options)"
            class="p-item-list-panel-large__item__specs"
          ></ItemSpecs>
        </div>
        <div class="p-item-list-panel-large__point">
          <PointNotation
            :point="point"
            :font-size="itemPointFontSize"
            :unit="unit"
            :sign-is-exists="false"
          />
          <span
            v-if="discountRate"
            class="p-item-list-panel-large__point__discount_rate"
            >（{{ discountRate }}%OFF）</span
          >
        </div>
      </div>
      <div class="p-item-list-panel-large__buttons">
        <template>
          <ButtonMain
            v-if="isCart"
            tag="a"
            href="/cart-details/"
            kind="secondary"
            >カートを確認</ButtonMain
          >
          <!-- <ButtonMain
          :disabled="disabled"
          @click-button="addToCart()"
          v-else
          kind="main"
          >カートに入れる</ButtonMain
        > -->
        </template>

        <template>
          <!-- <TheC01ItemFormNotePanelShortage
          v-if="!userPointsAreGreaterThanProductPoint && hasStock && !isCart"
          :possession="possession"
          :credit-card-enabled="creditCardEnabled"
          :cart-empty="cartEmpty"
          :count="count"
          :type="type"
          class="p-item-list-panel-large__note"
        /> -->

          <!-- <TheC01ItemFormNotePanelGiftCard
          v-if="
            userPointsAreGreaterThanProductPoint &&
            !cartEmpty &&
            hasStock &&
            !isCart
          "
          :is-gift-card-and-normal-item-in-cart="isGiftCardAndNormalItemInCart"
          :is-normal-item-and-gift-card-in-cart="isNormalItemAndGiftCardInCart"
          class="p-item-list-panel-large__note"
        /> -->
          <!-- <TheC01ItemFormNotePanelDrink
          v-if="ageAlert && !isCart"
          :value="isAdult"
          @checked="onCheckAdult"
          class="p-item-list-panel-large__note"
        /> -->
        </template>

        <a
          href="javascript:void(0);"
          class="p-item-list-panel-large__delete"
          @click="emitDelete"
          >削除する</a
        >
      </div>
    </div>
  </li>
</template>

<script lang="ts">
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import TheC01ItemFormNotePanelShortage from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelShortage.vue";
import TheC01ItemFormNotePanelDrink from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelDrink.vue";
import TheC01ItemFormNotePanelGiftCard from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelGiftCard.vue";
import {
  getShoppingCartItems,
  postShoppingCartItems
} from "@/general/store/api";
import { ShoppingCartItemRequest } from "gen/ricapi/api";
import ItemSpecs from "@/general/components/molecules/ItemSpecs.vue";
import LocalStorage from "@/general/utils/storage";

@Options({
  props: {
    thumbnails: { type: Array, required: false, default: () => [] },
    status: { type: String, required: false, default: "" },
    name: { type: String, required: false, default: "" },
    id: { type: Number, required: false, default: "" },
    premiumId: { type: Number, required: false, default: "" },
    point: { type: Number, required: false, default: "" },
    usedPointsAfterAddToCart: { type: Number, required: false, default: "" },
    discountRate: { type: Number, required: false, default: "" },
    isCart: { type: Boolean, required: false, default: false },
    supplierCreditcard: { type: Boolean, required: false, default: false },
    stock: { type: Number, required: true, default: 0 },
    stockControl: { type: Boolean, required: true, default: false },
    type: { type: String, required: true, default: "normal" },
    color: { type: String, required: true },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    ageAlert: { type: Boolean, required: true },
    page: { type: String, required: true }
  },
  components: {
    TextLabel,
    ButtonMain,
    PointNotation,
    TheC01ItemFormNotePanelShortage,
    TheC01ItemFormNotePanelDrink,
    TheC01ItemFormNotePanelGiftCard,
    ItemSpecs
  }
})
export default class ItemListPanelLarge extends Vue {
  thumbnails!: any;
  status!: string;
  name!: string;
  id!: number;
  premiumId!: number;
  point!: number;
  usedPointsAfterAddToCart!: number;
  discountRate!: number;
  isCart!: boolean;
  supplierCreditcard!: boolean;
  stock!: any;
  stockControl!: boolean;
  type!: any;
  color!: any;
  options!: any;
  ageAlert!: boolean;
  page!: string;
  creditCardEnabled = false;
  count = 1;

  isAdult = false;
  cartItem: any = [];

  // get colorCode() {
  //   return this.stock > 0 ? commons.colorCode : "#333";
  // }

  get showSpecs() {
    return this.page === "favorite";
  }

  get unit() {
    return commons.OrgPageSpecific?.point_name;
  }
  get isSp() {
    return globals.isSpScreenWidth;
  }
  get itemPointFontSize() {
    return this.isSp ? 28 : 24;
  }
  emitDelete() {
    this.$emit("delete");
  }

  get hasStock() {
    return this.stock > 0;
  }

  get productRequiredpoints() {
    return this.point * 1;
  }

  get userPointsAreGreaterThanProductPoint() {
    const userPoints = this.possession;
    const productRequiredpoints = this.productRequiredpoints;
    return userPoints >= productRequiredpoints;
  }

  get possession() {
    const userPoints = LocalStorage.getItem("userPointsDetails")
      ? JSON.parse(LocalStorage.getItem("userPointsDetails") as string)
      : "";

    if (userPoints !== "") {
      return (
        userPoints.total_points -
        userPoints.thanks_exclusive_points -
        this.usedPointsAfterAddToCart
      );
    } else {
      return 0;
    }
  }

  get isGiftCardAndNormalItemInCart() {
    const isGiftCard = this.type === "gift_card";

    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 1
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }
  get isNormalItemAndGiftCardInCart() {
    const isNormalItem = this.type === "normal";
    const hasGiftCardInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type !== 1
    );
    return (
      isNormalItem && hasGiftCardInCart && this.stock > 0 && this.possession > 0
    );
  }

  get cartItemCount() {
    return parseInt(LocalStorage.getItem("cartItemCount") as string);
  }

  get cartEmpty() {
    return this.cartItemCount == 0;
  }

  async created() {
    const cartItems = await getShoppingCartItems(1, 90, "");

    LocalStorage.setItem("cartDetails", JSON.stringify(cartItems?.results));
    this.cartItem = cartItems?.results;

    const skuIds: any = [];
    cartItems.results?.forEach((item) => {
      skuIds.push(item?.sku_id);
    });

    LocalStorage.setItem("cartSkuIds", JSON.stringify(skuIds));
    const creditCardEnabled = this.creditCardEnabledAdmin;
    if (creditCardEnabled === 0 && this.supplierCreditcard) {
      this.creditCardEnabled = creditCardEnabled;
    }
  }

  get disabled() {
    if (this.hasStock) {
      if (this.possession >= this.productRequiredpoints) {
        //credit card not required
        if (this.cartItemCount > 0) {
          if (
            this.isGiftCardAndNormalItemInCart ||
            this.isNormalItemAndGiftCardInCart
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        if (this.possession < 1) {
          return true;
        }
        //credit required
        if (this.creditCardEnabled) {
          if (this.cartItemCount > 0 || this.count != 1) {
            return true;
          } else {
            if (this.type !== "gift_card") {
              return false;
            } else {
              return true;
            }
          }
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  get setOpacity() {
    if (!this.stockControl) {
      return { opacity: 1, "vertical-align": "baseline" };
    }
    if (!this.stock) {
      return { opacity: 0.3, "vertical-align": "baseline" };
    }
    return false;
  }

  async addToCart() {
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    const shoppingCartItemRequest: ShoppingCartItemRequest = {
      user: userDetails.id,
      sku_id: this.id,
      quantity: this.count
    };
    const response = await postShoppingCartItems(shoppingCartItemRequest);
    if (response) {
      window.location.href = "/cart-details";
    }
  }

  getSpecs(options: any) {
    const specs = options.map((item: any) => {
      return { term: item.option_type_name, description: item.value };
    });

    return specs;
  }

  get creditCardEnabledAdmin() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];

    // return orgAdminSettings[0].self_pay_enabled;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.self_pay_enabled;
    }
    return false;
  }
}
</script>

<style lang="scss" scoped>
.p-item-list-panel-large {
  padding: rem(24) 0;
  border-top: px(1) solid $common-gray-border;
  // display: flex;
  // align-items: center;
  // flex-direction: row;

  @include large-sp {
    flex-direction: column;
  }

  &__content {
    // display: flex;
    // justify-content: space-between;

    @include pc {
      margin-right: rem(56);
    }
  }

  &__thumbnail {
    // width: 100% * (160 / 729);
    width: 150px !important;
    height: 150px !important;
  }

  &__thumbnail img {
    // width: 100% * (160 / 729);
    width: 150px !important;
    height: 150px !important;
  }

  &__info {
    width: 50%;
    display: inline-block;
    margin-left: 20px;
    // padding-left: 15px !important;
  }

  &__name {
    @include text__body--l;
    margin-top: rem(16);
    display: block;
    width: 70%;

    @include large-sp {
      margin-top: rem(12);
      width: 100%;
    }
  }

  &__id {
    @include text__body--s;
    color: $common-gray500;
    margin-top: rem(8);
  }

  &__point {
    margin-top: rem(16);

    @include pc {
      display: flex;
      align-items: center;
    }

    &__discount_rate {
      color: $common-primary;
      @include text__body--s;

      @include pc {
        margin-left: rem(16);
      }
    }
  }

  &__buttons {
    // display: flex;
    // flex-direction: column;
    // align-items: flex-end;
    // position: absolute;
    // right: 200px;
    display: inline-block;
    float: right;
    @include large-sp {
      margin-top: rem(24);
      position: relative;
      right: 0px;
    }
  }

  &__delete {
    @include text__body--s;
    margin-top: rem(16);
    display: inline-block;
    float: right;
  }

  &__shortage {
    @include text__body--s;
    margin-top: rem(16);
    padding: rem(16);
    display: flex;
    letter-spacing: 0;
    border: px(1) solid $error;
    color: $error;
    width: 100%;
    max-width: rem(288);
    line-height: rem(16);
  }

  &__note {
    margin-top: rem(40);

    @include sp {
      margin-top: rem(32);
      display: flex;
      justify-content: center;
    }
  }

  &__item {
    padding: rem(24) 0;
    border-top: px(1) solid $common-gray-border;

    &__columns {
      display: flex;
    }
    &__column_thumbnail {
      width: 100% * (160 / 736);

      @include large-sp {
        flex-basis: rem(80);
        flex-shrink: 0;
        margin-right: rem(12);
      }
    }
    &__column_info {
      width: 100% * (536 / 736);
      margin-right: 0;
      margin-left: auto;

      @include large-sp {
        width: auto;
        flex: 1;
      }
    }
    &__status {
      margin-left: px(1);
    }
    &__name {
      @include text__body--l;
      line-height: (22/16);
      margin-top: rem(16);
      display: block;

      @include large-sp {
        margin-top: rem(12);
      }
    }
    &__id {
      color: $common-black-sub;
      margin-top: rem(8);

      @include large-sp {
        font-size: rem(14);
      }
    }
    &__point {
      margin-top: rem(12);
      display: flex;
      align-items: center;

      @include large-sp {
        margin-top: rem(12);
        display: block;
      }

      &__discount_rate {
        margin-left: rem(16);
        @include text__body--s;

        @include large-sp {
          margin-left: 0;
        }
      }
    }
    &__details {
      width: 100% * (536 / 736);
      @include large-sp {
        width: 100%;
      }
    }
  }
}
</style>
